class ViewMessageWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.translate = this.injector.get('$translate');
        this.state = this.injector.get('$state');

        this.key = 'view-message';
        this.title = this.translate.instant('messages.workflows.list.view.title');
        this.level = 'row';
        this.icon = '';
    }

    action({row}, store) {
        const routeToGo = row.type === 'sms' ? 'app.messages.sms.details' : 'app.messages.details';
        return this.state.go(routeToGo, {
            id: row.id,
            message: row,
            store: store
        });
    }

}

angular
    .module('festzelt-os.modules.messages')
    .factory('viewMessage', [
        '$injector',
        $injector => new ViewMessageWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/list/view.js